import { createAsyncThunk } from "@reduxjs/toolkit";

import {
    getUnclaimedOrders as getUnclaimedOrdersApi,
    markUnclaimedOrderHandled as markUnclaimedOrderHandledApi,
    markOrderAsUnclaimed as markOrderAsUnclaimedApi,
} from "../../../helpers/backend_helper";

export interface FetchUnclaimedOrdersParams {
    page?: number;
    pageSize?: number;
    query?: string;
    append?: boolean;
    [key: string]: any;
}

export interface MarkUnclaimedOrderHandledParams {
    orderId: string | number;
    data?: Record<string, any>;
}

export interface MarkOrderAsUnclaimedParams {
    orderId: string | number;
    data?: Record<string, any>;
}

export const fetchUnclaimedOrders = createAsyncThunk(
    "unclaimedOrders/fetch",
    async (params?: FetchUnclaimedOrdersParams) => {
        try {
            const { append: _append, ...queryParams } = params ?? {};
            const normalizedParams: Record<string, any> = { ...queryParams };

            if (!normalizedParams.status) {
                normalizedParams.status = "unclaimed";
            }

            if (normalizedParams.query === undefined || normalizedParams.query === "") {
                delete normalizedParams.query;
            }

            if (normalizedParams.pageSize !== undefined) {
                normalizedParams.limit = normalizedParams.pageSize;
                delete normalizedParams.pageSize;
            }

            return await getUnclaimedOrdersApi(normalizedParams);
        } catch (error: any) {
            throw error;
        }
    }
);

export const markUnclaimedOrderHandled = createAsyncThunk(
    "unclaimedOrders/markHandled",
    async ({ orderId, data }: MarkUnclaimedOrderHandledParams) => {
        try {
            return await markUnclaimedOrderHandledApi(orderId, data ?? {});
        } catch (error: any) {
            throw error;
        }
    }
);

export const markOrderAsUnclaimed = createAsyncThunk(
    "unclaimedOrders/markOrderAsUnclaimed",
    async ({ orderId, data }: MarkOrderAsUnclaimedParams) => {
        try {
            return await markOrderAsUnclaimedApi(orderId, data ?? {});
        } catch (error: any) {
            throw error;
        }
    }
);
